import { render, staticRenderFns } from "./DeliveryPointsNumberForm.vue?vue&type=template&id=5ec56dd4&scoped=true&"
import script from "./DeliveryPointsNumberForm.vue?vue&type=script&lang=js&"
export * from "./DeliveryPointsNumberForm.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryPointsNumberForm.vue?vue&type=style&index=0&id=5ec56dd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec56dd4",
  null
  
)

export default component.exports